import * as React from 'react';
import farmguardIcon from '../assets/img/farmguard.png';
import doorlockIcon from '../assets/img/doorlock.png';
import smarttimecontrollerIcon from '../assets/img/smarttimecontroller.png';
import motionsensorIcon from '../assets/img/motion-sensor.png';

const icons = {
  'Farm Guard': farmguardIcon,
  'Smart Door Lock Detector and Monitor': doorlockIcon,
  'Smart Timer Controller': smarttimecontrollerIcon,
  'Smart Motion Detector': motionsensorIcon,
};

const CardComponent = ({ data }) => (
  <article className="landing-product">
    <img src={icons[data.name]} alt="" width="64" height="64" loading="lazy" decoding="async" />
    <h3>{data.name}</h3>
    <dl>
      {['Type', 'Features', 'Sensor', 'Range', 'Brand'].map(field => (
        <div key={field}>
          <dt>{field}</dt>
          <dd>{data[field]}</dd>
        </div>
      ))}
    </dl>
  </article>
);

export default CardComponent;
